<template>
  <div class="product">
    <div class="banner-div">
      <img :src="require(`@/assets/images/${languages}/product/banner.jpg`)">
    </div>
    <div class="main-box">
      <img :src="require(`@/assets/images/${languages}/product/img.jpg`)">
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex';
  export default{
    data(){
      return{
        resDatas:''
      }
    },
    computed: {
      ...mapState(["languages", "languagesData"]), // 在这里引入你需要的state值
    },
    methods:{

    },
    mounted() {
      this.$store.state.highlight = 'index';
    }
  }
</script>

<style scoped>
  .product{
background: url('~@/assets/images/traditional/product/bg.jpg') bottom center no-repeat;
    background-size: auto 100%;
    height: 100%;
  }
  .main-box{
    width: 100%;
    overflow: hidden;
    position: relative;

    text-align: center;
  }
  .main-box img{
    max-width: 100%;
  }
  @media screen and (max-width: 1000px){
    .product{

    }
    .main-box img{
      width: 76%;
      margin: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/product.vue